import './App.scss';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Projects from './containers/projects/Projects';
import Home from './containers/home/Home';
import Services from './containers/services/Services';
import Dashboard from './components/dashboard/Dashboard';
import AdminProjects from './containers/admin/adminProjects/AdminProjects';
import AdminServices from './containers/admin/adminServices/AdminServices';
import './App.scss';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import ContactForm from './components/ContactForm/ContactForm';
import About from './containers/about/About';
import Contact from './containers/contact/Contact';

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Navbar />
                <Routes>
                    <Route exact path="/" element={<Home />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/admin" element={<Dashboard />}>
                        <Route path="projects" element={<AdminProjects />} />
                        <Route path="services" element={<AdminServices />} />
                    </Route>
                </Routes>
                <ContactForm />
                <Footer />
            </BrowserRouter>
        </div>
    );
}

export default App;
